import { capexService } from '@modules/capex/infrastructure/capex.service'

type Callbacks = {
  onSuccess: (capexFile: Blob) => void
  onNetworkError: (error: unknown) => void
}

export function handleDownloadCapexFile() {
  return { execute }

  async function execute(
    configId: string,
    { onSuccess, onNetworkError }: Callbacks
  ) {
    try {
      const capexFile = (await capexService.exportCapexFile(configId)) as Blob
      onSuccess(capexFile)
    } catch (error) {
      onNetworkError(error)
    }
  }
}
